/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IProductFeatureViewProps } from './product-feature';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
export default (props: IProductFeatureViewProps) => {
    const { productFeature, productFeatureContainer, productFeatureGrid } = props;
    return (
        <Module {...productFeature}>
            <Node {...productFeatureContainer}>{productFeatureGrid}</Node>
        </Module>
    );
};
